import { SortingType } from '@components/Table/interface'
import { DonationQueryParam } from '@features/dashboard/pages/DonationPage/interface'

export enum OrderByEnum {
  TAG = 'TAG',
  TOTAL_SEARCH = 'TOTAL_SEARCH',
}

export interface HashtagParam {
  orderBy: OrderByEnum
  orderDirection: SortingType
}

export interface SearchResultByHashtagParam
  extends HashtagParam,
    DonationQueryParam {
  page: number
}
